module.exports = __webpack_public_path__ + "img/kilometer3.0e01dc81.svg";